import { Card, CardContent, CardMedia, Typography, Link } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import { Link as RouterLink } from 'react-router-dom';
import { useParams } from "react-router-dom";
import CategoryDto from "../../../models/CategoryDto"
import { CATEGORY_URL, HOMEPAGE, MENU_CARD_URL, SUB_CATEGORY_URL } from "../../../utils/Constants";

interface CategoryListCardItemProps {
    category: CategoryDto;
}

export default function CategoryListCardItem({ category }: CategoryListCardItemProps) {
    const params = useParams();
    const subCategories = category.subCategories;
    const url = `${HOMEPAGE}/${params.restaurantId}/${MENU_CARD_URL}/${CATEGORY_URL}/${category.id}/${SUB_CATEGORY_URL}/${subCategories.length ? subCategories[0].id : '0'}`;
    const hasImage = category.imageUrl && category.imageUrl.length > 0;
    return (
        <Card style={{
            height: 'auto',
            borderRadius: '0.75rem',
            background: "rgba(250, 250, 250, 255)",
            boxShadow: "0 0 0.625rem rgb(33, 103, 253)",
            border: 1
        }} sx={{ border: 1 }}>
            <Link component={RouterLink} to={url} style={{ textDecoration: 'none' }}>
                <CardContent sx={{ width: '100%', maxWidth:'100%', height: '100%' }}>
                    <Grid2 container spacing={3} alignItems="center" sx={{maxWidth:'100%'}}>
                        {/* Default 12 -> Half 6 6*/}
                        {hasImage &&
                            <Grid2 xs={6} display="flex" justifyContent="center" alignItems="center">
                                <CardMedia
                                    component="img"
                                    height={'auto'}
                                    image={category.imageUrl}
                                    alt={category.value}
                                    sx={{ boxShadow: '0.25rem 0.25rem 0.563rem rgb(37, 37, 37)', maxWidth: '30vh', minWidth: '15vh', maxHeight: '5.5rem', width: 'auto', borderRadius: '0.625rem', mt: '-0.313rem', mb: '-0.313rem' }}
                                />
                            </Grid2>
                        }
                        <Grid2 xs={hasImage ? 6 : 12}>
                            <Typography
                                sx={{ textShadow: '0 0 0.063rem rgb(33, 103, 253)', hyphens: 'auto' }}
                                fontSize='1.3rem'
                                textAlign={hasImage ? 'left' : 'center'}
                                align="center"
                                color="black"
                                fontWeight="800"
                            >
                                {category.value}
                            </Typography>
                        </Grid2>
                    </Grid2>
                </CardContent>
            </Link>
        </Card>
    );
}